import {
   Button,
   Modal,
   ModalOverlay,
   ModalContent,
   ModalHeader,
   ModalFooter,
   ModalBody,
   ModalCloseButton,
   useColorModeValue,
   Grid,
   GridItem,
   Input,
} from '@chakra-ui/react';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getBrand } from '../../../../redux/actions/brand';
import { getCategory } from '../../../../redux/actions/category';
import { getSeries } from '../../../../redux/actions/series';
import { renderDynamicDropdown } from 'components/ui/DynamicDropdown';
import { RAM_TYPE, STORAGE_TYPE } from '../../../../variables/company';
import { getColor } from '../../../../redux/actions/color';
import {
   getReportSaleDetail,
   getReportPurchaseDetail,
   getStoreStock,
   getBillToBillProfit,
   getInventoryDetailReport,
   getAllTransaction,
   getNoneSerialisedProfit,
   getReportSaleChallanDetail,
   getReportSaleOrderDetail,
   getReportMillIssue,
   getReportGrayPurchase,
   getReportPurchaseChallanDetail,
   getReportPurchaseOrderDetail,
} from '../../../../redux/actions/reports';
import { getAccount } from '../../../../redux/actions/account';
import { getItems } from '../../../../redux/actions/item';
import { getDaybook } from '../../../../redux/actions/daybook';
import { getUser } from '../../../../redux/actions/user';
import { useUser, useGlobal, useBusinessType } from 'contexts';
import { getLogs } from '../../../../redux/actions/logs';
import MultiSelectDropdown from 'components/ui/MultiSelectDropdown';
import AddEditForm from '../../masters/Pages/AllAccountMaster/AddEditFormForAccount';
import DaybookForm from '../../masters/Pages/DaybookMaster/DaybookForm';
import CategoryMasterForm from '../../masters/Pages/CategoryMaster/CategoryMasterForm';
import ItemForm from '../../masters/Pages/ItemMaster/ItemMasterForm';
import SeriesMasterForm from '../../masters/Pages/SeriesMaster/SeriesMasterForm';
import ColorMasterForm from '../../masters/Pages/ColorMaster/ColorMasterForm';
import BrandMasterForm from '../../masters/Pages/BrandMaster/BrandMasterForm';

function StockFilter({ isOpen, onClose, companyIds, fromDate, toDate, type, entityType, transactionType, typeFilter, methodFilter, onApply }) {
   const { user } = useUser();
   const { businessTypes } = useBusinessType();
   const isTextile = businessTypes?.businessType === 'TEXTILE';
   const shouldHideMobileFilters = isTextile;
   const dispatch = useDispatch();
   const { cityList, stateList, userGlobalSettingsData } = useGlobal();
   const textColor = useColorModeValue('#9E9E9E', 'white');
   const brandData = useSelector((state) => state.brand.list || []);
   const categoryData = useSelector((state) => state.category.list || []);
   const seriesData = useSelector((state) => state.series.list || []);
   const colorData = useSelector((state) => state.color.list || []);
   const accountData = useSelector((state) => state.account.list || []);
   const itemData = useSelector((state) => state.item.data || []);
   const daybookData = useSelector((state) => state.daybook.list || []);
   const userData = useSelector((state) => state.user.list || []);
   const brokerData = accountData.filter((account) => account.brokerId);
   const representativeData = userData.filter((user) => user.userType);
   const globalSettingAcc = userGlobalSettingsData?.[0]?.askCompany?.account;
   const shouldShowCompanyDropdownAcc = globalSettingAcc || false;
   const globalSettingDaybook = userGlobalSettingsData?.[0]?.askCompany?.daybook;
   const shouldShowCompanyDropdownDaybook = globalSettingDaybook || false;
   const globalSettingItem = userGlobalSettingsData?.[0]?.askCompany?.item;
   const shouldShowCompanyDropdownItem = globalSettingItem || false;
   const globalSettingBrand = userGlobalSettingsData?.[0]?.askCompany?.brand;
   const shouldShowCompanyDropdownBrand = globalSettingBrand || false;
   const globalSettingCategory = userGlobalSettingsData?.[0]?.askCompany?.category;
   const shouldShowCompanyDropdownCategory = globalSettingCategory || false;
   const globalSettingSeries = userGlobalSettingsData?.[0]?.askCompany?.series;
   const shouldShowCompanyDropdownSeries = globalSettingSeries || false;
   const globalSettingColor = userGlobalSettingsData?.[0]?.askCompany?.color;
   const shouldShowCompanyDropdownColor = globalSettingColor || false;
   // Check if entityType is salesDetail or purchaseDetail
   const showSalesPurchaseFields = entityType === 'salesDetail' || entityType === 'purchaseDetail' || entityType === 'salesChallanDetail' || entityType === 'salesOrderDetail' || entityType === 'millIssueDetail' || entityType === 'grayPurchaseDetail' || entityType === 'purchaseChallanDetail' || entityType === 'purchaseOrderDetail';
   const isBillToBillProfit = entityType === 'BillToBillProfit' || entityType === 'Inventory Detail';
   const isNoneSerialised = entityType === 'NoneSerialisedProfit';
   const allTransaction = entityType === 'allTransaction';
   const transactionHistory = entityType === 'transactionHistory';

   const businessType = localStorage.getItem('businessTypes');
   const mobile = businessType === 'MOBILE';

   const getDaybookType = (entityType) => {
      switch (entityType) {
         case 'salesDetail':
            return 5;
         case 'purchaseDetail':
            return 11;
         default:
            return;
      }
   };
   const daybookType = getDaybookType(entityType);

   useEffect(() => {
      if (isOpen) {
         // Always fetch these basic fields
         if (mobile) {
            dispatch(
               getBrand({
                  ...(shouldShowCompanyDropdownBrand &&
                     companyIds?.length && {
                     companyIds: companyIds.join(','),
                  }),
               }),
            );
            dispatch(
               getSeries({
                  ...(shouldShowCompanyDropdownSeries &&
                     companyIds?.length && {
                     companyIds: companyIds.join(','),
                  }),
               }),
            );
         }
         dispatch(
            getColor({
               ...(shouldShowCompanyDropdownColor &&
                  companyIds?.length && {
                  companyIds: companyIds.join(','),
               }),
            }),
         );
         dispatch(
            getItems({
               companyId: user.loginhistory.companyId,
               ...(shouldShowCompanyDropdownItem &&
                  companyIds?.length && {
                  companyIds: companyIds.join(','),
               }),
               status: true,
            }),
         );
         dispatch(
            getAccount({
               compId: user?.loginhistory?.companyId,
               status: true,
               ...(shouldShowCompanyDropdownAcc &&
                  companyIds?.length && {
                  companyIds: companyIds.join(','),
               }),
            }),
         );
         // dispatch(
         //    getDaybook({
         //       companyId: user.loginhistory.companyId,
         //       ...(shouldShowCompanyDropdownDaybook &&
         //          companyIds?.length && {
         //          companyIds: companyIds.join(','),
         //       }),
         //       type: daybookType,
         //    }),
         // );

         // Only fetch category if needed
         if (showSalesPurchaseFields || isBillToBillProfit || isNoneSerialised) {
            dispatch(
               getCategory({
                  ...(shouldShowCompanyDropdownCategory &&
                     companyIds?.length && {
                     companyIds: companyIds.join(','),
                  }),
               }),
            );
         }

         // Only fetch account/daybook/user data if needed
         if (showSalesPurchaseFields) {
            dispatch(getUser());
         }
      }
   }, [
      dispatch,
      isOpen,
      user,
      companyIds,
      entityType,
      showSalesPurchaseFields,
      shouldShowCompanyDropdownDaybook,
      shouldShowCompanyDropdownAcc,
      shouldShowCompanyDropdownItem,
      shouldShowCompanyDropdownBrand,
      shouldShowCompanyDropdownCategory,
      shouldShowCompanyDropdownColor,
      shouldShowCompanyDropdownSeries,
      isBillToBillProfit,
      isNoneSerialised,
   ]);

   const initialFormData = {
      colorIds: [],
      ram: '',
      seriesIds: [],
      categoryIds: [],
      brandIds: [],
      brokerIds: [],
      accountIds: [],
      itemIds: [],
      representativeIds: [],
      daybookIds: [],
      storage: '',
      serialNumber: '',
      docNumber: '',
      amount: '',
      cityId: [],
      stateId: [],
   };

   const [formData, setFormData] = useState(initialFormData);

   const handleBrandChange = (selectedValues) => {
      setFormData((prev) => ({ ...prev, brandIds: selectedValues || [] }));
   };

   const handleBrokerChange = (selectedValues) => {
      setFormData((prev) => ({ ...prev, brokerIds: selectedValues || [] }));
   };

   const handleAccountChange = (selectedValues) => {
      setFormData((prev) => ({ ...prev, accountIds: selectedValues || [] }));
   };

   const handleItemChange = (selectedValues) => {
      setFormData((prev) => ({ ...prev, itemIds: selectedValues || [] }));
   };

   const handleDaybookChange = (selectedValues) => {
      setFormData((prev) => ({ ...prev, daybookIds: selectedValues || [] }));
   };

   const handleRepresentativeChange = (selectedValues) => {
      setFormData((prev) => ({ ...prev, representativeIds: selectedValues || [] }));
   };

   const handleSerialNumberChange = (e) => {
      setFormData((prev) => ({ ...prev, serialNumber: e.target.value }));
   };

   const handleAmountChange = (e) => {
      setFormData((prev) => ({ ...prev, amount: e.target.value }));
   };

   const handleDocNumberChange = (e) => {
      setFormData((prev) => ({ ...prev, docNumber: e.target.value }));
   };

   const handleCategoryChange = (selectedValues) => {
      setFormData((prev) => ({ ...prev, categoryIds: selectedValues || [] }));
   };

   const handleSeriesChange = (selectedValues) => {
      setFormData((prev) => ({ ...prev, seriesIds: selectedValues || [] }));
   };

   const handleColorChange = (selectedValues) => {
      setFormData((prev) => ({ ...prev, colorIds: selectedValues || [] }));
   };

   const handleCityChange = (selectedValues) => {
      setFormData((prev) => ({ ...prev, cityId: selectedValues || [] }));
   };

   const handleStateChange = (selectedValues) => {
      setFormData((prev) => ({ ...prev, stateId: selectedValues || [] }));
   };

   const handleInputChange = (name, value) => {
      setFormData((prev) => ({
         ...prev,
         [name]: value,
      }));
   };

   const handleSubmit = (e) => {
      e.preventDefault();
      onApply?.();
      onClose();

      const toCsv = (v) => {
         if (v == null) return '';
         if (Array.isArray(v)) return v.join(',');
         if (typeof v === 'object') {
            if ('value' in v) return String(v.value);
            return Object.values(v).map(String).join(',');
         }
         return String(v);
      };

      // Create a base payload with required fields
      const payload = {
         ...(!transactionHistory ? { companyIds: companyIds.toString() } : { compIds: companyIds.toString() }),
         ...(transactionHistory && { transactionTypes: toCsv(transactionType), entryTypes: toCsv(type) }),
         fromDate: fromDate,
         toDate: toDate,
         ...(allTransaction ? { transactionType: type } : !transactionHistory ? { type: type } : {}),
         ...(isNoneSerialised && { type: typeFilter, costingMethod: methodFilter }),
         ...(entityType === 'Inventory Detail' && { orderBy: 'asc' }),
      };

      // Add optional fields only if they have values
      if (formData.colorIds.length) payload.colorIds = formData.colorIds.toString();
      if (formData.ram.length) payload.rams = formData.ram.toString();
      if (formData.seriesIds.length) payload.seriesIds = formData.seriesIds.toString();
      if (formData.brandIds.length) payload.brandIds = formData.brandIds.toString();
      if (formData.itemIds.length) payload.itemIds = formData.itemIds.toString();
      if (formData.storage.length) payload.storages = formData.storage.toString();
      if (formData.serialNumber) payload.serialNo = formData.serialNumber;
      if (formData.accountIds.length)
         allTransaction
            ? (payload.accountIds = formData.accountIds.toString())
            : (payload.accIds = formData.accountIds.toString());
      if (formData.daybookIds.length) payload.daybookIds = formData.daybookIds.toString();
      if (transactionHistory && formData.docNumber)
         transactionType === 'voucher'
            ? (payload.voucherDocNo = formData.docNumber)
            : (payload.docNo = formData.docNumber);
      if (transactionHistory && formData.amount) payload.amount = formData.amount;

      // Only include sales/purchase specific fields if needed
      if (showSalesPurchaseFields) {
         if (formData.categoryIds.length) payload.categoryIds = formData.categoryIds.toString();
         if (formData.brokerIds.length) payload.brokerIds = formData.brokerIds.toString();
         if (formData.representativeIds.length) payload.representativeIds = formData.representativeIds.toString();
      }
      if (isBillToBillProfit) {
         if (entityType === 'BillToBillProfit') {
            if (formData.categoryIds.length) payload.categoryIds = formData.categoryIds.toString();
         } else if (entityType === 'Inventory Detail') {
            if (formData.categoryIds.length) payload.categoryIds = formData.categoryIds.toString();
         }
      }
      if (isNoneSerialised) {
         if (entityType === 'NoneSerialisedProfit') {
            if (formData.categoryIds.length) payload.categoryIds = formData.categoryIds.toString();
         }
      }

      if (entityType === 'storeStock' && formData.cityId.length > 0) {
         payload.cityIds = formData.cityId.join(',');
      }

      if (entityType === 'purchaseDetail' && formData.cityId.length > 0) {
         payload.cityIds = formData.cityId.join(',');
      }

      if (entityType === 'storeStock' && formData.stateId.length > 0) {
         payload.stateIds = formData.stateId.join(',');
      }

      if (entityType === 'purchaseDetail' && formData.stateId.length > 0) {
         payload.stateIds = formData.stateId.join(',');
      }

      // Dispatch based on entityType
      if (entityType === 'salesDetail') {
         dispatch(getReportSaleDetail(payload));
      } else if (entityType === 'purchaseDetail') {
         dispatch(getReportPurchaseDetail(payload));
      } else if (entityType === 'storeStock') {
         dispatch(getStoreStock(payload));
      } else if (entityType === 'BillToBillProfit') {
         dispatch(getBillToBillProfit(payload));
      } else if (entityType === 'NoneSerialisedProfit') {
         dispatch(getNoneSerialisedProfit(payload));
      } else if (entityType === 'Inventory Detail') {
         dispatch(getInventoryDetailReport(payload));
      } else if (entityType === 'allTransaction') {
         dispatch(getAllTransaction(payload));
      } else if (entityType === 'transactionHistory') {
         dispatch(getLogs(payload));
      } else if (entityType === 'salesChallanDetail') {
         dispatch(getReportSaleChallanDetail(payload));
      } else if (entityType === 'salesOrderDetail') {
         dispatch(getReportSaleOrderDetail(payload));
      } else if (entityType === 'millIssueDetail') {
         dispatch(getReportMillIssue(payload));
      } else if (entityType === 'grayPurchaseDetail') {
         dispatch(getReportGrayPurchase(payload));
      } else if (entityType === 'purchaseChallanDetail') {
         dispatch(getReportPurchaseChallanDetail(payload));
      } else if (entityType === 'purchaseOrderDetail') {
         dispatch(getReportPurchaseOrderDetail(payload));
      } else if (entityType === 'PurchaseReturnDetail') {
         dispatch(getReportPurchaseDetail({ ...payload, isReturn: 1 }));
      } else if (entityType === 'SalesReturnDetail') {
         dispatch(getReportSaleDetail({ ...payload, isReturn: 1 }));
      }

      onClose();
   };

   const handleClear = () => {
      setFormData(initialFormData);
      // Create a minimal payload with only required fields
      const payload = {
         companyIds: companyIds.toString(),
         fromDate: fromDate,
         toDate: toDate,
         type: type,
      };

      // Dispatch based on entityType
      if (entityType === 'salesDetail') {
         dispatch(getReportSaleDetail(payload));
      } else if (entityType === 'purchaseDetail') {
         dispatch(getReportPurchaseDetail(payload));
      } else if (entityType === 'storeStock') {
         dispatch(getStoreStock(payload));
      } else if (entityType === 'BillToBillProfit') {
         dispatch(getBillToBillProfit(payload));
      } else if (entityType === 'NoneSerialisedProfit') {
         dispatch(getNoneSerialisedProfit(payload));
      } else if (entityType === 'Inventory Detail') {
         dispatch(getInventoryDetailReport(payload));
      } else if (entityType === 'salesChallanDetail') {
         dispatch(getReportSaleChallanDetail(payload));
      } else if (entityType === 'salesOrderDetail') {
         dispatch(getReportSaleOrderDetail(payload));
      } else if (entityType === 'millIssueDetail') {
         dispatch(getReportMillIssue(payload));
      } else if (entityType === 'grayPurchaseDetail') {
         dispatch(getReportGrayPurchase(payload));
      } else if (entityType === 'purchaseChallanDetail') {
         dispatch(getReportPurchaseChallanDetail(payload));
      } else if (entityType === 'purchaseOrderDetail') {
         dispatch(getReportPurchaseOrderDetail(payload));
      } else if (entityType === 'PurchaseReturnDetail') {
         dispatch(getReportPurchaseDetail({ ...payload, isReturn: 1 }));
      }
      onClose();
   };

   const isColorMode = useColorModeValue(true, false);

   return (
      <Modal isOpen={isOpen} onClose={onClose} size="xl">
         <ModalOverlay />
         <ModalContent as="form" onSubmit={handleSubmit}>
            <ModalHeader>Filter</ModalHeader>
            <ModalCloseButton />
            <ModalBody pb={6}>
               <Grid templateColumns="repeat(2, 1fr)" gap={4}>
                  {/* Serial Number Input */}
                  {entityType?.toLowerCase() !== 'inventory detail' && transactionType !== 'voucher' && !isNoneSerialised && entityType !== 'salesChallanDetail' && entityType !== 'salesOrderDetail' && entityType !== 'millIssueDetail' && entityType !== 'grayPurchaseDetail' && entityType !== 'purchaseChallanDetail' && entityType !== 'purchaseOrderDetail' && !shouldHideMobileFilters && (
                     <Input
                        placeholder="Enter Serial Number"
                        name="serialNumber"
                        value={formData.serialNumber}
                        onChange={handleSerialNumberChange}
                     />
                  )}
                  {transactionHistory && (
                     <Input
                        placeholder="Enter Doc Number"
                        name="docNumber"
                        value={formData.docNumber}
                        onChange={handleDocNumberChange}
                     />
                  )}
                  {transactionHistory && (
                     <Input
                        placeholder="Enter Amount"
                        name="amount"
                        value={formData.amount}
                        onChange={handleAmountChange}
                     />
                  )}
                  <GridItem>
                     <MultiSelectDropdown
                        label="Account"
                        options={accountData}
                        value={formData.accountIds}
                        onChange={handleAccountChange}
                        placeholder="Select Account"
                        isRequired={true}
                        showAddButton={true}
                        onAddNew={(value) => console.log('handleAddNew', value)}
                        isLoading={false}
                        darkMode={!isColorMode}
                        AddEditFormComponent={AddEditForm}
                        error={''}
                     />
                  </GridItem>

                  {/* Account Dropdown */}
                  {/* <GridItem>
                     {renderDynamicDropdown(
                        'accountid',
                        'Account',
                        accountData,
                        {
                           value: formData.accountIds,
                           onChange: handleAccountChange,
                           showCustomNoOptions: true,
                           openfrom: 'account',
                        },
                        {},
                        textColor,
                        true,
                        'Select Account',
                        true,
                        undefined,
                        true,
                     )}
                  </GridItem> */}
                  {/* Daybook Dropdown */}
                  <GridItem>
                     {/* {renderDynamicDropdown(
                        'daybookid',
                        'Daybook',
                        daybookType ? daybookData.filter((dd) => dd.type === daybookType) : daybookData,
                        {
                           value: formData.daybookIds,
                           onChange: handleDaybookChange,
                           showCustomNoOptions: true,
                           openfrom: 'daybook',
                        },
                        {},
                        textColor,
                        true,
                        'Select Daybook',
                        true,
                        undefined,
                        true,
                     )} */}
                     <MultiSelectDropdown
                        label="Daybook"
                        options={daybookType ? daybookData.filter((dd) => dd.type === daybookType) : daybookData}
                        value={formData.daybookIds}
                        onChange={handleDaybookChange}
                        placeholder="Select Daybook"
                        isRequired={true}
                        showAddButton={true}
                        onAddNew={(value) => console.log('handleAddNew', value)}
                        isLoading={false}
                        darkMode={!isColorMode}
                        AddEditFormComponent={DaybookForm}
                        error={''}
                     />
                  </GridItem>

                  {isBillToBillProfit || isNoneSerialised && (
                     <GridItem>
                        {/* {renderDynamicDropdown(
                           'categoryid',
                           'Category',
                           categoryData,
                           {
                              value: formData.categoryIds,
                              onChange: handleCategoryChange,
                              showCustomNoOptions: true,
                              openfrom: 'category',
                           },
                           {},
                           textColor,
                           true,
                           'Select Category',
                           true,
                           undefined,
                           true,
                        )} */}
                        <MultiSelectDropdown
                           label="Category"
                           options={categoryData}
                           value={formData.categoryIds}
                           onChange={handleCategoryChange}
                           placeholder="Select Category"
                           isRequired={true}
                           showAddButton={true}
                           onAddNew={(value) => console.log('handleAddNew', value)}
                           isLoading={false}
                           darkMode={!isColorMode}
                           AddEditFormComponent={CategoryMasterForm}
                           error={''}
                        />
                     </GridItem>
                  )}

                  {/* Only show these fields for sales/purchase */}
                  {showSalesPurchaseFields && (
                     <>
                        {/* Broker Dropdown */}
                        <GridItem className="seperator-width">
                           {/* {renderDynamicDropdown(
                              'brokerId',
                              'Broker',
                              brokerData,
                              {
                                 value: formData.brokerIds,
                                 onChange: handleBrokerChange,
                              },
                              textColor,
                              true,
                              'Select Broker',
                              true,
                              undefined,
                              true,
                           )} */}
                           <MultiSelectDropdown
                              label="Broker"
                              options={brokerData}
                              value={formData.brokerIds}
                              onChange={handleBrokerChange}
                              placeholder="Select Broker"
                              isRequired={true}
                              showAddButton={false}
                              onAddNew={(value) => console.log('handleAddNew', value)}
                              isLoading={false}
                              darkMode={!isColorMode}
                              AddEditFormComponent={null}
                              error={''}
                           />
                        </GridItem>

                        {/* Representative Dropdown */}
                        <GridItem>
                           {/* {renderDynamicDropdown(
                              'representativeid',
                              'Representative',
                              representativeData,
                              {
                                 value: formData.representativeIds,
                                 onChange: handleRepresentativeChange,
                              },
                              {},
                              textColor,
                              true,
                              'Select Representative',
                              true,
                              undefined,
                              true,
                           )} */}
                           <MultiSelectDropdown
                              label="Representative"
                              options={representativeData}
                              value={formData.representativeIds}
                              onChange={handleRepresentativeChange}
                              placeholder="Select Representative"
                              isRequired={true}
                              showAddButton={false}
                              onAddNew={(value) => console.log('handleAddNew', value)}
                              isLoading={false}
                              darkMode={!isColorMode}
                              AddEditFormComponent={null}
                              error={''}
                           />
                        </GridItem>
                        {entityType !== 'salesChallanDetail' && entityType !== 'salesOrderDetail' && entityType !== 'millIssueDetail' && entityType !== 'grayPurchaseDetail' && entityType !== 'purchaseChallanDetail' && entityType !== 'purchaseOrderDetail' && <GridItem>
                           {/* {renderDynamicDropdown(
                              'categoryid',
                              'Category',
                              categoryData,
                              {
                                 value: formData.categoryIds,
                                 onChange: handleCategoryChange,
                                 showCustomNoOptions: true,
                                 openfrom: 'category',
                              },
                              {},
                              textColor,
                              true,
                              'Select Category',
                              true,
                              undefined,
                              true,
                           )} */}
                           <MultiSelectDropdown
                              label="Category"
                              options={categoryData}
                              value={formData.categoryIds}
                              onChange={handleCategoryChange}
                              placeholder="Select Category"
                              isRequired={true}
                              showAddButton={true}
                              onAddNew={(value) => console.log('handleAddNew', value)}
                              isLoading={false}
                              darkMode={!isColorMode}
                              AddEditFormComponent={CategoryMasterForm}
                              error={''}
                           />
                        </GridItem>}
                     </>
                  )}

                  {/* These fields are shown for all entity types */}
                  {/* Brand Dropdown */}
                  {!allTransaction && !transactionHistory && mobile && !shouldHideMobileFilters && (
                     <GridItem>
                        {/* {renderDynamicDropdown(
                           'brandid',
                           'Brand',
                           brandData,
                           {
                              value: formData.brandIds,
                              onChange: handleBrandChange,
                              showCustomNoOptions: true,
                              openfrom: 'brand',
                           },
                           {},
                           textColor,
                           true,
                           'Select Brand',
                           true,
                           undefined,
                           true,
                        )} */}
                        <MultiSelectDropdown
                           label="Brand"
                           options={brandData}
                           value={formData.brandIds}
                           onChange={handleBrandChange}
                           placeholder="Select Brand"
                           isRequired={true}
                           showAddButton={true}
                           onAddNew={(value) => console.log('handleAddNew', value)}
                           isLoading={false}
                           darkMode={!isColorMode}
                           AddEditFormComponent={BrandMasterForm}
                           error={''}
                        />
                     </GridItem>
                  )}
                  {/* Item Dropdown */}
                  {transactionType !== 'voucher' && (
                     <GridItem>
                        {/* {renderDynamicDropdown(
                           'itemid',
                           'Item',
                           itemData,
                           {
                              value: formData.itemIds,
                              onChange: handleItemChange,
                              showCustomNoOptions: true,
                              openfrom: 'item',
                           },
                           {},
                           textColor,
                           true,
                           'Select Item',
                           true,
                           undefined,
                           true,
                        )} */}
                        <MultiSelectDropdown
                           label="Item"
                           options={itemData}
                           value={formData.itemIds}
                           onChange={handleItemChange}
                           placeholder="Select Item"
                           isRequired={true}
                           showAddButton={true}
                           onAddNew={(value) => console.log('handleAddNew', value)}
                           isLoading={false}
                           darkMode={!isColorMode}
                           AddEditFormComponent={ItemForm}
                           error={''}
                        />
                     </GridItem>
                  )}
                  {/* Series Dropdown */}
                  {!allTransaction && !transactionHistory && !isNoneSerialised && mobile && !shouldHideMobileFilters && (
                     <GridItem>
                        {/* {renderDynamicDropdown(
                           'seriesId',
                           'Series',
                           seriesData,
                           {
                              value: formData.seriesIds,
                              onChange: handleSeriesChange,
                              showCustomNoOptions: true,
                              openfrom: 'series',
                           },
                           {},
                           textColor,
                           true,
                           'Select Series',
                           true,
                           undefined,
                           true,
                        )} */}
                        <MultiSelectDropdown
                           label="Series"
                           options={seriesData}
                           value={formData.seriesIds}
                           onChange={handleSeriesChange}
                           placeholder="Select Series"
                           isRequired={true}
                           showAddButton={true}
                           onAddNew={(value) => console.log('handleAddNew', value)}
                           isLoading={false}
                           darkMode={!isColorMode}
                           AddEditFormComponent={SeriesMasterForm}
                           error={''}
                        />
                     </GridItem>
                  )}
                  {!allTransaction && !transactionHistory && entityType !== 'salesChallanDetail' && entityType !== 'salesOrderDetail' && entityType !== 'millIssueDetail' && entityType !== 'grayPurchaseDetail' && entityType !== 'purchaseChallanDetail' && entityType !== 'purchaseOrderDetail' && (
                     <GridItem>
                        {/* {renderDynamicDropdown(
                           'colorId',
                           'Color',
                           colorData,
                           {
                              value: formData.colorIds,
                              onChange: handleColorChange,
                              showCustomNoOptions: true,
                              openfrom: 'color',
                           },
                           {},
                           textColor,
                           true,
                           'Select Color',
                           true,
                           undefined,
                           true,
                        )} */}
                        <MultiSelectDropdown
                           label="Color"
                           options={colorData}
                           value={formData.colorIds}
                           onChange={handleColorChange}
                           placeholder="Select Color"
                           isRequired={true}
                           showAddButton={true}
                           onAddNew={(value) => console.log('handleAddNew', value)}
                           isLoading={false}
                           darkMode={!isColorMode}
                           AddEditFormComponent={ColorMasterForm}
                           error={''}
                        />
                     </GridItem>
                  )}
                  {!allTransaction && !transactionHistory && mobile && !shouldHideMobileFilters && (
                     <GridItem>
                        {/* {renderDynamicDropdown(
                           'ramId',
                           'RAM',
                           RAM_TYPE,
                           {
                              value: formData.ram,
                              onChange: (value) => handleInputChange('ram', value),
                           },
                           {},
                           textColor,
                           false,
                           'Select RAM',
                           true,
                           undefined,
                           true,
                        )} */}
                        <MultiSelectDropdown
                           label="RAM"
                           options={RAM_TYPE}
                           value={formData.ram}
                           onChange={(value) => handleInputChange('ram', value)}
                           placeholder="Select RAM"
                           isRequired={true}
                           showAddButton={false}
                           onAddNew={(value) => console.log('handleAddNew', value)}
                           isLoading={false}
                           darkMode={!isColorMode}
                           AddEditFormComponent={null}
                           error={''}
                        />
                     </GridItem>
                  )}
                  {!allTransaction && !transactionHistory && mobile && !shouldHideMobileFilters && (
                     <GridItem>
                        {/* {renderDynamicDropdown(
                           'storageId',
                           'Storage',
                           STORAGE_TYPE,
                           {
                              value: formData.storage,
                              onChange: (value) => handleInputChange('storage', value),
                           },
                           {},
                           textColor,
                           false,
                           'Select Storage',
                           true,
                           undefined,
                           true,
                        )} */}
                        <MultiSelectDropdown
                           label="Storage"
                           options={STORAGE_TYPE}
                           value={formData.storage}
                           onChange={(value) => handleInputChange('storage', value)}
                           placeholder="Select Storage"
                           isRequired={true}
                           showAddButton={false}
                           onAddNew={(value) => console.log('handleAddNew', value)}
                           isLoading={false}
                           darkMode={!isColorMode}
                           AddEditFormComponent={null}
                           error={''}
                        />
                     </GridItem>
                  )}

                  {['storeStock', 'purchaseDetail', 'salesChallanDetail', 'salesOrderDetail',
                     'millIssueDetail', 'grayPurchaseDetail', 'purchaseChallanDetail', 'purchaseOrderDetail']
                     .includes(entityType) && (
                        <GridItem>
                           <MultiSelectDropdown
                              label="City"
                              options={cityList}
                              value={formData.cityId}
                              onChange={handleCityChange}
                              placeholder="Select City"
                              isRequired={true}
                              showAddButton={false}
                              onAddNew={(value) => console.log('handleAddNew', value)}
                              isLoading={false}
                              darkMode={!isColorMode}
                              AddEditFormComponent={null}
                              error={''}
                           />
                        </GridItem>
                     )}

                  {['storeStock', 'purchaseDetail', 'salesChallanDetail', 'salesOrderDetail',
                     'millIssueDetail', 'grayPurchaseDetail', 'purchaseChallanDetail', 'purchaseOrderDetail']
                     .includes(entityType) && (
                        <GridItem>
                           <MultiSelectDropdown
                              label="State"
                              options={stateList}
                              value={formData.stateId}
                              onChange={handleStateChange}
                              placeholder="Select State"
                              isRequired={true}
                              showAddButton={false}
                              onAddNew={(value) => console.log('handleAddNew', value)}
                              isLoading={false}
                              darkMode={!isColorMode}
                              AddEditFormComponent={null}
                              error={''}
                           />
                        </GridItem>
                     )}
               </Grid>
            </ModalBody>

            <ModalFooter>
               <Button type="submit" colorScheme="green" mr={3}>
                  Apply Filters
               </Button>
               <Button onClick={handleClear}>Reset</Button>
            </ModalFooter>
         </ModalContent>
      </Modal>
   );
}

export default StockFilter;
